import BaseResource from './index'
import JobTitleResource from './jobTitle'
import EntitiesResource from './entities'
import RateUnitResource from './rateUnit'
import DepartmentResource from './department'
import AgreementResource from './agreement'
import UnionLocalResource from './unionLocal'
import FlsaResource from './flsatype'
import LegislativeResource from './legislativeType'

export default class AssignmentResource extends BaseResource {
    static endpoint = '/oasis/restv3/admin/assignments'

    static related() {
        return {
            job_title_id: JobTitleResource,
            entity_id: EntitiesResource,
            rate_unit_id: RateUnitResource,
            department_id: DepartmentResource,
            agreement_id: AgreementResource,
            union_local_id: UnionLocalResource,
            flsa_type_id: FlsaResource,
            legislative_type_id: LegislativeResource,
        }
    }
}
